import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import PopupHeader from '../../popupHeader';
import TextInput from '../../../inputs/textInput.js';
import Modal from 'components/shared/modal/content';
import { showDeleteOrganizationModal } from 'actions/modal.js';
import { initializeOrgDeletion } from 'actions/organisation.js';

export default function DeleteOrganizationModal(props) {
  const dispatch = useDispatch();
  const [shouldDisplayTextBox, setShouldDisplayTextBox] = useState(false);
  const [userInput, setUserInput] = useState('');

  const confirmDeleteOrg = () => {
    dispatch(initializeOrgDeletion(props.selectedOrganization, closeConfirmationModal, props.cbAfterDeletion));
  };

  const closeConfirmationModal = () => {
    dispatch(showDeleteOrganizationModal(false));
  };

  const showTextBox = () => {
    setShouldDisplayTextBox(true);
  };

  const isApiCallInProgress = () =>
    props.meetingRoomsDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.IN_PROGRESS ||
    props.waitingAreasDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.IN_PROGRESS ||
    props.organizationDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.IN_PROGRESS;

  let removeBtnClasses =
    'ui mrtm labeled icon button icon left-text color-button mrbnull color-button-hover mrpcrxs color-white mrlnull max-width';
  return (
    <Modal show={true} hideWhenClickAway={false} isSingleColumnModal={true} className="remove-tag single-column-modal">
      <PopupHeader
        hideHelp={true}
        title={window.APP.LANGUAGE.DeleteOrganization.Title}
        subtitle={props.selectedOrganization.name}
      />
      <div className="content">
        <div className="main-ui-container content-horizontally-centred mrrnull">
          <div id="righthandfloatingpanel">
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <h4 className="title-sms">{window.APP.LANGUAGE.DeleteOrganization.DeleteOrganizationInfo1}</h4>
              <div className="title-sms mrbm">{window.APP.LANGUAGE.DeleteOrganization.DeleteOrganizationInfo2}</div>
              <div className="title-sms mrbm">{window.APP.LANGUAGE.DeleteOrganization.DeleteOrganizationInfo3}</div>
              {shouldDisplayTextBox && !isApiCallInProgress() && (
                <>
                  <div className="title-sms mrbm">
                    <span>{window.APP.LANGUAGE.DeleteOrganization.DeleteOrganizationInfo4}</span>
                    <span className="bold">{` ${window.APP.LANGUAGE.Delete.toLowerCase()} `}</span>
                    <span>{window.APP.LANGUAGE.DeleteOrganization.DeleteOrganizationInfo5}</span>
                  </div>
                  <TextInput
                    onChange={(e) => setUserInput(e)}
                    value={userInput}
                    fieldClasses="ui input max-width special"
                    id="text-input"
                  />
                </>
              )}
              {isApiCallInProgress() && (
                <>
                  <div className="title-sms mrtm">
                    <span className="bold">{`${window.APP.LANGUAGE.DeleteOrganization.DeletingWaitingAreas}: `}</span>
                    <span>
                      {props.waitingAreasDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED &&
                        window.APP.LANGUAGE.DeleteOrganization.NotStarted}
                    </span>
                    <span className="red-message">
                      {props.waitingAreasDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.IN_PROGRESS &&
                        window.APP.LANGUAGE.DeleteOrganization.InProgress}
                    </span>
                    <span className="green-message">
                      {props.waitingAreasDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.COMPLETED &&
                        window.APP.LANGUAGE.DeleteOrganization.Completed}
                    </span>
                  </div>
                  <div className="title-sms mrtm">
                    <span className="bold">{`${window.APP.LANGUAGE.DeleteOrganization.DeletingMeetingRooms}: `}</span>
                    <span>
                      {props.meetingRoomsDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED &&
                        window.APP.LANGUAGE.DeleteOrganization.NotStarted}
                    </span>
                    <span className="red-message">
                      {props.meetingRoomsDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.IN_PROGRESS &&
                        window.APP.LANGUAGE.DeleteOrganization.InProgress}
                    </span>
                    <span className="green-message">
                      {props.meetingRoomsDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.COMPLETED &&
                        window.APP.LANGUAGE.DeleteOrganization.Completed}
                    </span>
                  </div>
                  <div className="title-sms mrtm">
                    <span className="bold">{`${window.APP.LANGUAGE.DeleteOrganization.DeletingOrganization}: `}</span>
                    <span>
                      {props.organizationDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.NOT_STARTED &&
                        window.APP.LANGUAGE.DeleteOrganization.NotStarted}
                    </span>
                    <span className="red-message">
                      {props.organizationDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.IN_PROGRESS &&
                        window.APP.LANGUAGE.DeleteOrganization.InProgress}
                    </span>
                    <span className="green-message">
                      {props.organizationDeletionStatus === window.APP.LANGUAGE.API_CALL_STATUS.COMPLETED &&
                        window.APP.LANGUAGE.DeleteOrganization.Completed}
                    </span>
                  </div>
                </>
              )}
              <div className="ui actions max-width">
                <button
                  type="button"
                  id="remove-cancel-btn"
                  disabled={isApiCallInProgress()}
                  onClick={closeConfirmationModal}
                  className={`ui cancel labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrrnull ${
                    shouldDisplayTextBox && 'mrtm'
                  }`}
                >
                  <i className="remove  icon" />
                  {APP.LANGUAGE.Cancel}
                </button>
                <button
                  type="button"
                  id="remove-save-btn"
                  disabled={
                    shouldDisplayTextBox &&
                    (userInput.toUpperCase() !== window.APP.LANGUAGE.Delete.toUpperCase() || isApiCallInProgress())
                  }
                  onClick={shouldDisplayTextBox ? confirmDeleteOrg : showTextBox}
                  className={isApiCallInProgress() ? removeBtnClasses + ' loading remove-save-btn' : removeBtnClasses}
                >
                  {APP.LANGUAGE.Delete}
                  <i className="checkmark icon " />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

DeleteOrganizationModal.propTypes = {
  selectedOrganization: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  cbAfterDeletion: PropTypes.func.isRequired,
};
